import request from '../utils/request';

// 获取IP白名单列表
export const getIPWhitelistList = (params) => {
    return request.get('/ip_white/get_list', { params });
};

// 删除IP白名单
export const deleteIPWhitelist = (id) => {
    return request.get('/ip_white/delete', { params: { id } });
};

// 添加IP到白名单
export const createIPWhitelist = (ips) => {
    return request.post('/ip_white/create', { ip: ips });
};
